import { z } from 'zod';

const HivemindPersonSchema = z.object({
  id: z.number(),
  email: z.string(),
  name: z.string().nullable(),
});

// `teammate` is the wire name for the other person of the conversation
export const HivemindConversationSchema = z.object({
  id: z.string(),
  teammate: HivemindPersonSchema,
  chat_id: z.string(),
  topic: z.string(),
  // A plain string: a backend that adds a value must not break this app
  status: z.string(),
  // The teammate's latest message when it is the answer. Absent until the backend sends it
  answer: z.string().nullish(),
});

export const HivemindChatResponseSchema = z.object({
  threads: z.array(HivemindConversationSchema),
});

export type HivemindChat = z.infer<typeof HivemindChatResponseSchema>;

export const HivemindGroupsResponseSchema = z.object({
  groups: z.array(
    z.object({ name: z.string(), members: z.array(HivemindPersonSchema) })
  ),
});

export type HivemindGroup = z.infer<
  typeof HivemindGroupsResponseSchema
>['groups'][number];
